module.exports = __webpack_public_path__ + "img/building.bb6d5935.png";